<div class="find-panel"  (click)="find()">
  <input #search  id="search" [hidden]="false"
         class="subscribe"
         [(ngModel)]="findStr"
         [placeholder]="'Искать на полках'"
         (keyup.enter)="find()"
         (focusout)="find()"
         [formControl]="findStrControl">
</div>

